import * as MuiIcons from '@mui/icons-material';

/**
 * Icon Service
 * Dynamically loads Material-UI icons by name
 */

/**
 * Get icon component by name
 * @param {string} iconName - Name of the Material-UI icon
 * @returns {React.Component} The icon component or a default car icon
 */
export const getIconComponent = (iconName) => {
    // Return the icon if it exists, otherwise return a default
    return MuiIcons[iconName] || MuiIcons.DirectionsCar;
};

/**
 * Validate if an icon name exists
 * @param {string} iconName - Name of the Material-UI icon
 * @returns {boolean} True if the icon exists
 */
export const iconExists = (iconName) => {
    return !!MuiIcons[iconName];
};

/**
 * Get a list of commonly used vehicle-related icons
 * @returns {Array} Array of icon options with name and label
 */
export const getVehicleIconOptions = () => {
    return [
        { name: 'LocalShipping', label: 'Krankentransportwagen' },
        { name: 'LocalTaxi', label: 'Taxi' },
        { name: 'DirectionsCar', label: 'Auto' },
        { name: 'Accessible', label: 'Rollstuhlgerecht' },
        { name: 'DriveEta', label: 'Privat KFZ' },
        { name: 'AirportShuttle', label: 'Shuttle' },
        { name: 'ElectricCar', label: 'Elektrofahrzeug' },
        { name: 'TwoWheeler', label: 'Zweirad' },
        { name: 'DirectionsBus', label: 'Bus' },
        { name: 'ElectricRickshaw', label: 'Elektrisches Dreirad' },
        { name: 'Commute', label: 'Pendlerfahrzeug' },
        { name: 'TimeToLeave', label: 'Einsatzfahrzeug' }
    ];
};